export default __webpack_public_path__ + "static/media/Medical.e8aaea25.jpg";